import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    image: data?.image,
    ...data?.localized_data,
    display_priority: data?.display_priority || "",
    is_featured: data?.is_featured || false,
  };
};

export const structure = (t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "file",
        label: `${t("common.image")}*`,
        width: "100%",
      },
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("lookups_subcategories.name_en")}*`,
        width: "47%",
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: `${t("lookups_subcategories.name_ar")}*`,
        width: "47%",
      },
      {
        name: `display_priority`,
        kind: "input",
        type: "number",
        label: t("lookups_categories.display_priority"),
        width: "47%",
      },
      {
        name: `is_featured`,
        kind: "checkbox",
        type: "text",
        label: t("lookups_categories.is_featured"),
        width: "47%",
      },
      {
        name: `is_voucher`,
        kind: "checkbox",
        type: "text",
        label: t("lookups_categories.vouchers"),
        width: "47%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    en: Yup.object().shape({
      name: Yup.string().required("Required"),
    }),
    ar: Yup.object().shape({
      name: Yup.string().required("Required"),
    }),
    image: Yup.mixed().required("Required"),
    display_priority: Yup.number().typeError("Must be a number").nullable(),
    is_featured: Yup.boolean(),
  });
